//Replaces space in an URL with %20
export var replaceSpaceInUrl = function replaceSpaceInUrl(url) {
  return url === null || url === void 0 ? void 0 : url.replaceAll(' ', '%20');
};
var REGEX_SELECT_FIRST_SLASH = /\/$/;
var REGEX_SELECT_LAST_SLASH = /^\//;
export var preparingURLSegment = function preparingURLSegment(urlSegment) {
  if (!urlSegment) {
    return '';
  }
  return "".concat(urlSegment.replace(REGEX_SELECT_FIRST_SLASH, '').replace(REGEX_SELECT_LAST_SLASH, ''));
};